import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { generalFontSize, selectLineHeight, theme } from '@app/helpers';

export const menuPropsV2: any = {
    anchorOrigin: {
        vertical: 38,
        horizontal: 'left'
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
    },
    getContentAnchorEl: null
};

const passlySelectStyles: any = {
    borderRadius: theme.shape.borderRadius,
    position: 'relative',
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.input.border.default}`,
    fontSize: generalFontSize,
    lineHeight: selectLineHeight,
    transition: theme.transitions.create(['border-color', 'box-shadow', 'background-color']),

    '&.Mui-focused, &:focus, &$focused': {
        borderColor: theme.palette.primary.main
    },
    '&:hover': {
        borderColor: theme.palette.primary.main
    },
    '&.Mui-disabled': {
        '&:hover': {
            backgroundColor: theme.palette.background.default
        },
        backgroundColor: theme.palette.background.default
    },
    '&.Mui-error': {
        borderColor: theme.palette.error.main
    },
    '&.Mui-selected': {
        backgroundColor: theme.palette.action.selected
    },
    '.MuiPaper-root.MuiMenu-paper': {
        maxHeight: '200px'
    },
    '.MuiPaper-root.MuiMenu-paper .MuiMenuItem-root': {
        height: '32px',
        lineHeight: '32px',
        padding: 0
    }
};

const passlyTextFieldStyles: any = {
    borderRadius: theme.shape.borderRadius,
    position: 'relative',
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.input.border.default}`,
    fontSize: generalFontSize,
    lineHeight: selectLineHeight,
    transition: theme.transitions.create(['border-color', 'box-shadow', 'background-color']),

    '&.MuiInputBase-root': {
        '&.Mui-focused, &:focus, &$focused': {
            borderColor: theme.input.border.focused
        },
        '&.Mui-error': {
            borderColor: theme.palette.error.main
        },
    },

    '&:hover': {
        borderColor: theme.input.border.hovered
    },
    '&.Mui-disabled': {
        '&:hover': {
            backgroundColor: theme.palette.background.default
        },
        backgroundColor: theme.palette.background.default
    },
    '&.Mui-selected': {
        backgroundColor: theme.palette.action.selected
    },
    '.MuiPaper-root.MuiMenu-paper': {
        maxHeight: '200px'
    },
    '.MuiPaper-root.MuiMenu-paper .MuiMenuItem-root': {
        height: '32px',
        lineHeight: '32px',
        padding: 0
    }
};

export const createLabelStylesV2 = createStyles({
    root: {
        color: theme.inputLabel.color,
        fontFamily: `'Roboto', 'IBM Plex Sans', 'sans-serif'`,
        fontSize: 12,
        lineHeight: '14px',
        fontWeight: 500,
        '&$focused': {
            color: theme.inputLabel.color
        }
    },
    focused: {},
    shrink: {
        transform: 'translate(0, -3px) scale(1)'
    }
});

export const createSelectStylesV2 = createStyles({
    root: {
        ...passlySelectStyles,
        minWidth: 200,
        width: 'auto'
    },
    input: {
        padding: '8px 8px'
    },
    placeholder: {
        color: '#999999'
    },
    focused: {}
});

export const createTextFieldStylesV2 = createStyles({
    root: {
        ...passlyTextFieldStyles,
        width: 'auto'
    },
    input: {
        padding: '8px 8px'
    },
    placeholder: {
        color: '#999999'
    },
    focused: {}
});

export const createReadonlyTextFieldStylesV2 = createStyles({
    root: {
        ...passlyTextFieldStyles,
        border: '0 none',
        backgroundColor: theme.palette.background.default
    }
});

export const createSelectIconV2 = createStyles({
    root: {
        margin: '2px 4px 0 0',
        color: '#999999'
    },
    focused: {}
});

export const menuPaperStylesV2 = makeStyles((theme) => ({
    menuPaper: {
        maxHeight: '200px',
        '& .MuiMenuItem-root': {
            lineHeight: '32px',
            height: '32px',
            padding: '0 16px'
        }
    }
}));
export const useLabelStylesV2 = makeStyles((theme: Theme) => createLabelStylesV2);
export const useSelectStylesV2 = makeStyles((theme: Theme) => createSelectStylesV2);
export const useTextFieldStylesV2 = makeStyles((theme: Theme) => createTextFieldStylesV2);
export const useReadonlyTextFieldStylesV2 = makeStyles((theme: Theme) => createReadonlyTextFieldStylesV2);
export const useSelectIconV2 = makeStyles((theme: Theme) => createSelectIconV2);
